import { constantsTypes } from '../reduxConstants'

export const setMovieDetailsViewMode = (value) => {
  return {
    type: constantsTypes.MOVIE_DETAILS_VIEW,
    value: value,
  }
}
